<template>
  <div>
    <nav-breadcrumb :menu="[{label: '部门管理'}]"/>
    <panel style="height:100%">
      <el-row>
        <el-col :span="6">
          <el-tree
            :data="data"
            :props="defaultProps"
            :default-expand-all="true"
            @node-click="handleNodeClick"
          ></el-tree>
        </el-col>
        <el-col :span="18">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>当前部门：{{selected.name||'所有部门'}}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-row>
            <el-button type="primary" size="small" style="float:right;" @click="editItem()">新增部门</el-button>
          </el-row>
          <el-row>
            <data-table-component
              :table-data="tableData"
              :columns="tableColumns"
            />
          </el-row>
        </el-col>
      </el-row>
    </panel>
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle">
      <form-build-component
        form-name="ConfigDepartmentEditForm"
        :form-data.sync="form"
        :form-columns="formColumns"
        :form-rules="formRules"
        :form-buttons="formButtons"
      ></form-build-component>
    </el-dialog>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import DataTableComponent from "../../../components/DataTable";
  import FormBuildComponent from "../../../components/FormBuild";
  import {removeItem} from "../../../filters/CommonActions";
  
  export default {
    name: "ConfigDepartmentList",
    components: {FormBuildComponent, DataTableComponent},
    data() {
      return {
        data: [],
        defaultProps: {
          children: 'dept',
          label: 'name'
        },
        departmentListOptions: [],
        selected: {},
        dialogVisible: false,
        tableData: {},
        tableColumns: [
          {
            label: '部门名称',
            field: 'd__departmentName'
          },
          {
            label: '部门编号',
            field: 'd__departmentCode'
          },
          {
            label: '部门简称',
            field: 'd__abbreviation'
          },
          {
            label: '操作',
            opts: [
              {
                label: '编辑',
                class: 'el-icon-edit',
                clickHandler: (index,row)=> {
                  this.editItem(index, row)
                }
              },
              {
                label: '删除',
                class: 'el-icon-delete',
                clickHandler:(index, row)=>{
                  this.removeItem(index,row)
                }
              }
            ]
          }
        ],
        form: {
          d__parentId: '',
          d__departmentName: '',
          d__departmentCode: '',
          d__abbreviation: ''
        },
        formRules: {
          d__departmentName: [
            {
              required: true,
              message: '部门名称不能为空！'
            }
          ],
          d__departmentCode: [
            {
              required: true,
              message: '部门编号不能为空！'
            }
          ],
        },
        formButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler:$refs=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.onSubmit()
                }
              })
            }
          },
          {
            label: '取消',
            // type: 'primary',
            clickHandler:$refs=>{
              this.dialogVisible = false
            }
          }
        ]
      }
   },
    mounted() {
      this.getConfigDepartmentAsTree()
      this.getConfigDepartmentList()
    },
    computed: {
      dialogTitle() {
        return this.form.d__departmentCode  ? '编辑部门' : '新增部门'
      },
      formColumns: {
        get() {
          return [
            {
              label: '上级部门',
              component: 'el-select',
              field: 'd__parentId',
              span: 24,
              filterable: true,
              options: this.departmentListOptions
            },
            {
              label: '部门名称',
              component: 'el-input',
              field: 'd__departmentName',
              span: 24,
            },
            {
              label: '部门编号',
              component: 'el-input',
              field: 'd__departmentCode',
              span: 24,
            },
            {
              label: '部门简称',
              component: 'el-input',
              field: 'd__abbreviation',
              span: 24,
            }
          ]
        }
      }
    },
    methods: {
      getConfigDepartmentSelectOptions: function(arr) {
        arr.forEach(item=>{
          this.departmentListOptions.push({
            label: item.name,
            value: item.id
          })
          if( Array.isArray(item.dept)) {
            this.getConfigDepartmentSelectOptions(item.dept)
          }
        })
      },
      getConfigDepartmentAsTree: function () {
        xhr.getConfigDepartmentAsTree(
          {},
          res=>{
            try {
              if(res.data.status == 'success') {
                this.data = res.data.data.dept

                this.departmentListOptions = [
                  {
                    label: '所有部门',
                    value: ''
                  }
                ]
                this.getConfigDepartmentSelectOptions(this.data)
              }
            }catch (e) {
              
            }
          }
        )
      },
      getConfigDepartmentList: function(parentId= this.selected.id||'') {
        xhr.getConfigDepartmentList(
          {
            'd.parentId': parentId
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.tableData = res.data

              }
            }catch (e) {

            }
          }
        )
      },
      handleNodeClick(data) {
        this.selected = data
        this.getConfigDepartmentList(data.id)
      },
      removeItem: function (index, row) {
        removeItem(
          xhr.deleteConfigDepartment,
          {
            'd.departmentId' : row.d__departmentId
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.getConfigDepartmentAsTree()
                this.getConfigDepartmentList(this.selected.id)
              }
            }catch (e) {

            }
          }
        )
      },
      editItem(index, row) {
        if(typeof row == 'object') {
          this.form = Object.assign({}, row)
          this.form.d__parentId = this.form.d__parentId||this.selected.id||''
        }
        else {
          this.form = {
            d__parentId: '',
            d__departmentName: '',
            d__departmentCode: '',
            d__abbreviation: ''
          }
          this.form.d__parentId = this.selected.id||''
        }

        this.dialogVisible = true
      },
      onSubmit:function () {
        xhr.updateDepartment(
          this.form,
          res=>{
            try {
              if(res.data.status == 'success') {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
                this.dialogVisible = false
                this.getConfigDepartmentAsTree()
                this.getConfigDepartmentList()
              }
              else {
                this.$message({
                  type: 'error',
                  message: '保存失败！'
                })
              }
            }catch (e) {

            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigDepartmentList.vue